import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { MsalGuard } from '@azure/msal-angular'
import { BrowserUtils } from '@azure/msal-browser'

const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard',
    },
    {
        path: 'dashboard',
        loadChildren: () => import('./pages/live-dashboard/live-dashboard.module').then((m) => m.LiveDashboardModule),

        data: {
            title: 'Dashboard',
            navLabel: 'Dashboard',
            navIcon: 'live_dashboard',
        },
    },
    {
        path: 'insightsHub',
        loadChildren: () =>
            import('./pages/reporting-dashboard/reporting-dashboard.module').then((m) => m.ReportingDashboardModule),

        data: {
            title: 'Insights Hub',
            navLabel: 'Insights Hub',
            navIcon: 'reporting_dashboard',
        },
    },
    // {
    //     path: 'tickets',
    //     loadChildren: () => import('./pages/alerts/alerts.module').then((m) => m.AlertsModule),

    //     data: {
    //         title: 'Tickets',
    //         navLabel: 'Tickets',
    //         navIcon: 'alerts',
    //     },
    // },
    {
        path: 'predict-iq',
        loadChildren: () =>
            import('./pages/predict-iq/predict-iq.module').then((m) => m.PredictIqModule),

        data: {
            title: 'Predict IQ',
            navLabel: 'PredictIQ',
                navIcon: 'PredictIQ_brain_svg',
        },
    },
    {
        path: 'tickets',
        loadChildren: () => import('./pages/tickets/tickets.module').then((m) => m.TicketsModule),

        data: {
            title: 'Tickets',
            navLabel: 'Tickets',
            navIcon: 'Tickets',
        },
    },
    {
        path: 'ticket-analytics',
        loadChildren: () =>
            import('./pages/ticket-management/ticket-management.module').then((m) => m.TicketManagementModule),

        data: {
            title: 'Ticket Analytics',
            navLabel: 'Ticket Analytics',
            navIcon: 'ticket_management',
        },
    },
    {
        path: 'feedback-analytics',
        loadChildren: () =>
            import('./pages/customer-satisfaction/customer-satisfaction.module').then(
                (m) => m.CustomerSatisfactionModule
            ),

        data: {
            title: 'Feedback Analytics',
            navLabel: 'Feedback Analytics',
            navIcon: 'customer_satisfaction',
        },
    },
    {
        path: 'health-monitoring',
        loadChildren: () =>
            import('./pages/health-monitoring/health-monitoring.module').then((m) => m.HealthMonitoringModule),

        data: {
            title: 'Health Monitoring',
            navLabel: 'Health Monitoring',
            navIcon: 'application_status',
        },
    },
    {
        path: 'aipo-observability',
        loadChildren: () =>
            import('./pages/aipo-observability/aipo-observability.module').then((m) => m.AipoObservabilityModule),

        data: {
            title: 'Observability',
            navLabel: 'Observability',
            navIcon: 'AIPO_observability',
        },
    },
    {
        path: 'log-analysis',
        loadChildren: () =>
            import('./pages/log-analysis/log-analysis-table.module').then((m) => m.LogAnalysisTableModule),

        data: {
            title: 'Log Analysis',
            navLabel: 'Log Analysis',
            navIcon: 'log-analysis',
        },
    },
    {
        path: 'reliability-engineering',
        loadChildren: () =>
            import('./pages/reliability-engineering/reliability-engineering.module').then((m) => m.ReliabilityEngineeringModule),

        data: {
            title: 'Reliability Engineering',
            navLabel: 'Reliability Engineering',
            navIcon: 'reliability-engineering',
        },
    },
    {
        path: 'devops-automation',
        loadChildren: () =>
            import('./pages/devops-automation/devops-automation.module').then((m) => m.DevopsAutomationModule),

        data: {
            title: 'DevOps Automation',
            navLabel: 'Accelerators',
            navIcon: 'devOps',
        },
    },
    {
        path: 'connectors',
        loadChildren: () => import('./pages/connectors/connectors.module').then((m) => m.ConnectorsModule),

        data: {
            title: 'Connectors',
            navLabel: 'Connectors',
            navIcon: 'connectors',
        },
    },
    {
        path: '**',
        redirectTo: 'dashboard',
    },
]

@NgModule({
    imports: [RouterModule.forRoot(routes,{
        useHash: true,
        scrollPositionRestoration: 'enabled',
        initialNavigation:
        !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup()
        ? 'enabledNonBlocking'
        : 'disabled',
      })],
    exports: [RouterModule],
})
export class AppRoutingModule {}
